import { Navigate, Route, Routes } from 'react-router-dom'
import Header from './components/Header'
import Menu from './components/Menu'
import Login from './pages/Login'
import './scss/_global-style.scss'
import { CSSProperties, useContext } from 'react'
import UserContext from './contexts/UserContext/context'
import Sidebar from './components/Sidebar'
import SidebarContext from './contexts/SidebarContext/context'
import Modal from './components/Modal'
import ToastContext from './contexts/ToastContext/context'
import Infobox from './components/Infobox'
import { useToast } from './hooks/useToast'
import TooltipContext from './contexts/TooltipContext/context'
import { usePaths } from './hooks/usePaths'
import { useWindowSize } from './hooks/useWindowSize'

const App = () => {
  const { user } = useContext(UserContext)
  const { sidebar } = useContext(SidebarContext)
  const { toast } = useContext(ToastContext)
  const { tooltip } = useContext(TooltipContext)

  const { removeToast } = useToast()
  const { paths, preferencePath } = usePaths()
  const { isFullSize } = useWindowSize()

  const contentStyles = () => {
    const lookup: CSSProperties = {}
    if (sidebar.isOpen && isFullSize) {
      lookup.width = `calc(100% - ${sidebar.width}px)`
    }
    return lookup
  }


  if (!user.initialized) {
    return null
  }

  // If not authenticated throw user to login page
  if (!user.access_token || user?.username?.length === 0) {
    return (
      <>
        <Login />
      </>
    )
  }

  return (
    <div className="App__pages">
      <Menu paths={Object.values(paths)} />
      <div className="App__pages-content">
        <Header />
        <div className="App__pages-content__main" style={contentStyles()}>
          <Routes>
            {Object.values(paths).map((path) => {
              const { url, elem, params } = path
              const fullPath = `${url}/${params || ''}`
              const isIndex = url === preferencePath
              if (isIndex) {
                return (
                  <>
                    <Route path="/" element={<Navigate to={url} />} />
                    <Route path={fullPath} element={elem} />
                  </>
                )
              }

              return <Route path={fullPath} element={elem} />
            })}
          </Routes>
          <Sidebar />
          <Sidebar type="infobar" />
          <div className="App__toast">
            {toast?.toasts.map((t, idx) => {
              return <Infobox {...t} type="toast" onClose={() => removeToast(idx)} />
            })}
          </div>
        </div>
      </div>
      <Modal />
      {tooltip.text && tooltip.style && (
        <div className="Tooltip__tooltip" style={tooltip.style} >{tooltip.text}</div>
      )}
    </div>
  )
}

export default App
